import { render, staticRenderFns } from "./SubitemTree.vue?vue&type=template&id=2adcbfbb"
import script from "./SubitemTree.vue?vue&type=script&lang=js"
export * from "./SubitemTree.vue?vue&type=script&lang=js"
import style0 from "./SubitemTree.vue?vue&type=style&index=0&id=2adcbfbb&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports